export {};
//# sourceMappingURL=Heading.types.js.map